export default __webpack_public_path__ + "static/media/arystofanes.155579d0.png";